import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import {
    CustomerTestimony,
    HomepageDetailI,
    Partner,
    News,
    CustomerFeedback,
} from './home.types';
import { ApiService } from 'app/shared/constant/api-service/api.service';
import { API_ENDPOINTS } from 'app/core/constants/api-endpoints.constant';
import { InterceptorSkipHeader } from 'app/auth/auth.interceptor';

@Injectable({
    providedIn: 'root',
})
export class HomePageService {
    constructor(
        private http: HttpClient,
        private _apiService: ApiService,
    ) {}

    getTestimonies(): Observable<CustomerTestimony[]> {
        return this.http.get<CustomerTestimony[]>(
            API_ENDPOINTS.BASE_URL + 'imsme/testimony',
            { headers: { [InterceptorSkipHeader]: InterceptorSkipHeader } },
        );
    }

    getHomepageDetails(): Observable<{ data: HomepageDetailI }> {
        return this.http.get<{ data: HomepageDetailI }>(
            API_ENDPOINTS.BASE_URL + 'imsme/homepage',
            { headers: { [InterceptorSkipHeader]: InterceptorSkipHeader } },
        );
    }

    getPartnerDetails(): Observable<{ data: Partner[] }> {
        return this.http.get<{ data: Partner[] }>(
            API_ENDPOINTS.BASE_URL + 'imsme/partners',
            { headers: { [InterceptorSkipHeader]: InterceptorSkipHeader } },
        );
    }

    getNewsHome(id?: any): Observable<{ data: News[] }> {
        let newsUrl = API_ENDPOINTS.BASE_URL + '';
        if (id) {
            newsUrl += `${API_ENDPOINTS.HOME_NEWS}` + '/' + id;
        } else {
            newsUrl += `${API_ENDPOINTS.HOME_NEWS}`;
        }
        return this.http.get<{ data: News[] }>(newsUrl, {
            headers: { [InterceptorSkipHeader]: InterceptorSkipHeader },
        });
    }

    submitContactUs(contactUsDetails): Observable<any> {
        return this.http.post(
            API_ENDPOINTS.BASE_URL + '' + `${API_ENDPOINTS.CONTACT_US}`,
            contactUsDetails,
            { headers: { [InterceptorSkipHeader]: InterceptorSkipHeader } },
        );
    }

    getProductList(): Observable<any> {
        return this._apiService.get(`${API_ENDPOINTS.PRODUCTS}`, {
            headers: { [InterceptorSkipHeader]: InterceptorSkipHeader },
        });
    }

    getFAQ(): Observable<any> {
        return this._apiService.get(`${API_ENDPOINTS.FAQ}`);
    }

    postCustomerFeedback(customerData: CustomerFeedback): Observable<any> {
        return this.http.post(
            API_ENDPOINTS.BASE_URL + '' + `${API_ENDPOINTS.TESTIMONY}`,
            customerData,
            { headers: { [InterceptorSkipHeader]: InterceptorSkipHeader } },
        );
    }
}
